function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "url(#paint0_linear_10902_342365)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.99121 5.60352V13H7.01562V5.60352H8.99121ZM6.89258 3.67578C6.89258 3.38867 6.99284 3.15169 7.19336 2.96484C7.39388 2.77799 7.66276 2.68457 8 2.68457C8.33268 2.68457 8.59928 2.77799 8.7998 2.96484C9.00488 3.15169 9.10742 3.38867 9.10742 3.67578C9.10742 3.96289 9.00488 4.19987 8.7998 4.38672C8.59928 4.57357 8.33268 4.66699 8 4.66699C7.66276 4.66699 7.39388 4.57357 7.19336 4.38672C6.99284 4.19987 6.89258 3.96289 6.89258 3.67578Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_10902_342365",
  x1: 0,
  y1: 8.08989,
  x2: 16,
  y2: 8.08989,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#497905"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#65A30D"
})));

var SvgIconInfoActive = function SvgIconInfoActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconInfoActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_info_active.e0131ae3.svg";
export { ForwardRef as ReactComponent };